import { connect } from 'react-redux';
import Modal from './Modal';
import { ApplicationState } from '../../state/store';
import {
  getIsModalOpen,
  getModalButtonText,
  getModalDescription,
  getModalOnConfirm,
  getModalTitle,
} from '../../state/modal/modalSelectors';
import { hideModal } from '../../state/modal/modalActions';

const mapStateToProps = (state: ApplicationState) => ({
  title: getModalTitle(state),
  description: getModalDescription(state),
  buttonText: getModalButtonText(state),
  isOpen: getIsModalOpen(state),
  onConfirm: getModalOnConfirm(state),
});

const mapDispatchToProps = {
  hideModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
